import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';

import metadata from './TanningSalonOperationsComponent.metadata.json5';
import styles from '../../../SpaAndWellCommonStyles.module.scss';
import TanningEquInformationComponent from '../subcomponents/TanningEquInformation/TanningEquInformationComponent';

function TanningSalonOperationsComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('TanningSalonOperationsComponent');

    const modelVM = _.get(submissionVM, pathUpdated);

    modelVM.value.isValidationReq = true;

    const calculateQuantities = () => {
        let totalQunatity = 0;

        const tanningSalon = modelVM.value.tanningEquipmentInfoDTO;

        if (tanningSalon.length > 0) {
            tanningSalon.forEach(element => {
                if (!_.isUndefined(element.quaFie)) {
                    totalQunatity += element.quaFie
                }
            })
        }

        _.set(modelVM, 'totnumofalltypofununiFie.value', totalQunatity)

        return totalQunatity;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        totnumofalltypofununiFie: {
            disabled: true,
            value: calculateQuantities()
        },
        arethemasdonbytheFie: {
            visible: !_.isUndefined(modelVM.value.istheanyMasoffFie) && modelVM.value.istheanyMasoffFie
        },
        tanningEquInformationComponent: {
            data: modelVM.tanningEquipmentInfoDTO,
            updateWizardData,
            submissionVM,
            TanningEquipmentInformationPath: `${pathUpdated}.tanningEquipmentInfoDTO`
        },
        areCliGivTanInsFie: {
            defaultValue: true
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            tanningEquInformationComponent: TanningEquInformationComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;
            if (changedPath === 'areCliGivTanInsFie') {
                submissionVM.value.lobData.spaAndWellLine.coverables.healthWellness.tanningSalonOperations.arecligivtaninsFie = false;
            } else {
                _.set(submissionVM, `${fullPath}`, value);
            }

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            // onModelChange={updateWizardData}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

TanningSalonOperationsComponent.propTypes = wizardProps;
export default withRouter(TanningSalonOperationsComponent);
